import { createSelector } from 'reselect'
import { mainCurrency } from './config'
import { ticker, fundsWithValueMergedByCrypto } from './funds'
import { find, get } from 'lodash'

export const highlightedCurrencies = state =>
  state.dashboard.highlightedCurrencies

export const highlightedCurrenciesBalance = createSelector(
  highlightedCurrencies,
  fundsWithValueMergedByCrypto,
  (highlightedCurrencies, fundsWithValueMergedByCrypto) =>
    // only when there is ONE currency selected
    highlightedCurrencies.length === 1 &&
    get(
      find(
        fundsWithValueMergedByCrypto,
        d => d.currency === highlightedCurrencies[0]
      ),
      'balance'
    )
)

const highlightedCurrenciesValueBTC = createSelector(
  highlightedCurrencies,
  ticker,
  fundsWithValueMergedByCrypto,
  (highlightedCurrencies, ticker, fundsWithValueMergedByCrypto) =>
    fundsWithValueMergedByCrypto
      .filter(f => highlightedCurrencies.indexOf(f.currency) > -1)
      .reduce((sum, f) => sum + f.balance * ticker.btc[f.currency].value, 0)
)

export const highlightedCurrenciesValue = createSelector(
  highlightedCurrencies,
  ticker,
  highlightedCurrenciesValueBTC,
  mainCurrency,
  (
    highlightedCurrencies,
    ticker,
    highlightedCurrenciesValueBTC,
    mainCurrency
  ) => highlightedCurrenciesValueBTC * ticker.fiat[mainCurrency].value
)



// WEBPACK FOOTER //
// ./src/selectors/dashboard.js